module.exports = __webpack_public_path__ + "79c99c127b43bfeeb812f2124c8b4c7f.png";